import { motion } from "framer-motion";
import { User, Mail, ChevronRight } from "lucide-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const PageBiodata = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      is_hijab: "false",
    },
  });

  const selectedGender = watch("gender");

  const onSubmit = (data) => {
    const updatedData = {
      biodata: {
        ...data,
        is_hijab: data.is_hijab === "true",
      },
    };

    localStorage.setItem(
      "photobooth_data",
      JSON.stringify(updatedData)
    );

    navigate("/question");
  };

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#f3f3f3]">
      {/* Pattern */}
      <div className="absolute inset-0 opacity-40">
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `
              repeating-linear-gradient(
                -45deg,
                rgba(255,255,255,0.5),
                rgba(255,255,255,0.5) 14px,
                transparent 14px,
                transparent 28px
              )
            `,
          }}
        />
      </div>

      {/* Glow */}
      <div className="absolute top-[-120px] left-1/2 h-[360px] w-[360px] -translate-x-1/2 rounded-full bg-red-500/20 blur-3xl" />

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col px-7 py-10">
        {/* Header */}
        <div>
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center text-[36px] font-black uppercase leading-none text-red-600"
          >
            Biodata
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-center text-sm leading-6 text-zinc-600"
          >
            Isi data dirimu untuk memulai pengalaman AI Photo Booth
          </motion.p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="mt-12 flex flex-1 flex-col"
        >
          <div className="space-y-6">
            {/* Nama */}
            <div>
              <label className="mb-3 block text-sm font-bold uppercase tracking-wider text-zinc-700">
                Nama Lengkap
              </label>

              <div className="flex h-[68px] items-center rounded-3xl bg-white px-5 shadow-lg">
                <User className="mr-4 text-red-500" size={22} />

                <input
                  type="text"
                  placeholder="Masukkan nama"
                  className="w-full bg-transparent text-lg text-zinc-800 outline-none placeholder:text-zinc-400"
                  {...register("name", {
                    required: "Nama wajib diisi",
                  })}
                />
              </div>

              {errors.name && (
                <p className="mt-2 text-sm text-red-500">
                  {errors.name.message}
                </p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="mb-3 block text-sm font-bold uppercase tracking-wider text-zinc-700">
                Email
              </label>

              <div className="flex h-[68px] items-center rounded-3xl bg-white px-5 shadow-lg">
                <Mail className="mr-4 text-red-500" size={22} />

                <input
                  type="email"
                  placeholder="Masukkan email"
                  className="w-full bg-transparent text-lg text-zinc-800 outline-none placeholder:text-zinc-400"
                  {...register("email", {
                    required: "Email wajib diisi",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Format email tidak valid",
                    },
                  })}
                />
              </div>

              {errors.email && (
                <p className="mt-2 text-sm text-red-500">
                  {errors.email.message}
                </p>
              )}
            </div>

            {/* Gender */}
            <div>
              <label className="mb-3 block text-sm font-bold uppercase tracking-wider text-zinc-700">
                Gender
              </label>

              <div className="grid grid-cols-2 gap-4">
                {/* Pria */}
                <label
                  className={`flex h-[70px] cursor-pointer items-center justify-center rounded-3xl border-2 text-lg font-bold shadow-lg transition active:scale-95 ${
                    selectedGender === "Pria"
                      ? "border-red-600 bg-red-600 text-white"
                      : "border-transparent bg-white text-zinc-700"
                  }`}
                >
                  <input
                    type="radio"
                    value="Pria"
                    className="hidden"
                    {...register("gender", {
                      required: "Pilih gender",
                    })}
                  />

                  Pria
                </label>

                {/* Wanita */}
                <label
                  className={`flex h-[70px] cursor-pointer items-center justify-center rounded-3xl border-2 text-lg font-bold shadow-lg transition active:scale-95 ${
                    selectedGender === "Wanita"
                      ? "border-red-600 bg-red-600 text-white"
                      : "border-transparent bg-white text-zinc-700"
                  }`}
                >
                  <input
                    type="radio"
                    value="Wanita"
                    className="hidden"
                    {...register("gender", {
                      required: "Pilih gender",
                    })}
                  />

                  Wanita
                </label>
              </div>

              {errors.gender && (
                <p className="mt-2 text-sm text-red-500">
                  {errors.gender.message}
                </p>
              )}
            </div>

           {/* Hijab Option */}
{selectedGender === "Wanita" && (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className="mt-2"
  >
    <label className="mb-3 block text-sm font-bold uppercase tracking-wider text-zinc-700">
      Hijab
    </label>

    <div className="grid grid-cols-2 gap-4">
      {/* Tidak */}
      <label
        className={`flex h-[70px] cursor-pointer items-center justify-center rounded-3xl border-2 text-lg font-bold shadow-lg transition active:scale-95 ${
          watch("is_hijab") !== "true"
            ? "border-red-600 bg-red-600 text-white"
            : "border-transparent bg-white text-zinc-700"
        }`}
      >
        <input
          type="radio"
          value="false"
          className="hidden"
          {...register("is_hijab")}
        />

        Tidak
      </label>

      {/* Berhijab */}
      <label
        className={`flex h-[70px] cursor-pointer items-center justify-center rounded-3xl border-2 text-lg font-bold shadow-lg transition active:scale-95 ${
          watch("is_hijab") === "true"
            ? "border-red-600 bg-red-600 text-white"
            : "border-transparent bg-white text-zinc-700"
        }`}
      >
        <input
          type="radio"
          value="true"
          className="hidden"
          {...register("is_hijab")}
        />

        Berhijab
      </label>
    </div>
  </motion.div>
)}
          </div>

          {/* Bottom Button */}
          <div className="mt-auto pt-10">
            <motion.button
              whileTap={{ scale: 0.97 }}
              whileHover={{ scale: 1.01 }}
              type="submit"
              className="flex h-[76px] w-full items-center justify-center gap-3 rounded-full bg-red-600 text-xl font-black uppercase tracking-wide text-white shadow-[0_12px_40px_rgba(255,0,0,0.25)]"
            >
              Lanjut
              <ChevronRight size={24} />
            </motion.button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PageBiodata;